/**
 * 取り消し・やり直し（索引 Issue #498 の段階 3）。**純関数**。
 *
 * 1 手 = **変更の直前の状態そのまま**。文書は丸ごと置換で持っているので、積んだものを戻せば元に戻る
 * （差分を持つと、コマンドを足すたびに逆操作も書くことになる）。
 */
const HISTORY_LIMIT = 200;

export const emptyHistory = () => ({ past: [], future: [] });

export const canUndo = (h) => (h?.past?.length ?? 0) > 0;
export const canRedo = (h) => (h?.future?.length ?? 0) > 0;

/** 変更の直前の状態を積む（やり直しの列は捨てる） */
export function record(h, snapshot, { limit = HISTORY_LIMIT } = {}) {
  const past = [...h.past, snapshot];
  return { past: past.length > limit ? past.slice(past.length - limit) : past, future: [] };
}

/** 取り消す → `{ snapshot, history }`（戻せなければ null）。`current` は今の状態（やり直しの列へ積む） */
export function undo(h, current) {
  if (!canUndo(h)) return null;
  return {
    snapshot: h.past[h.past.length - 1],
    history: { past: h.past.slice(0, -1), future: [...h.future, current] },
  };
}

export function redo(h, current) {
  if (!canRedo(h)) return null;
  return {
    snapshot: h.future[h.future.length - 1],
    history: { past: [...h.past, current], future: h.future.slice(0, -1) },
  };
}
